import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { VmeCommonModule } from '../../vme-common.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ChecklistCategoryItemComponent } from './checklist-category-item.component';

@NgModule({
  imports: [VmeCommonModule, VmeDirectivesModule, VmePipesModule],
  declarations: [ChecklistCategoryItemComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [ChecklistCategoryItemComponent],
})
export class ChecklistCategoryItemModule {}
